import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../base/dtos/base-search.dto';
import { FileDto } from '../../files/dtos/file.dto';
import { VehicleMakeListDto } from '../../vehicle-makes/dtos/vehicle-make-list.dto';

/**
 * Vehicle model DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleModelSearchDto extends BaseSearchDto {
	name!: string;
	externalReference?: string;
	make!: VehicleMakeListDto;
	files?: FileDto[];

	displayValue(): string | null {
		return `${this.name}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string | null {
		return null;
	}
}
